import React from 'react';
import SearchAppComponent from '@components/template/keyword/insight/searchAppComponent';
import GridComponent from '@components/template/keyword/insight/gridComponent';

const Insight = () => {
  return (
    <div className="app-info app-sugg">
      <h2 className="app-info-tit">Keyword Insight</h2>
      <SearchAppComponent />
      <GridComponent />
    </div>
  );
};

export default Insight;
